import {StateFilter, StateVisualData, StateVisualStep} from '../Store/State';

/**
 * Сформировать из текущего состояния фильтра строку запроса визуального режима.
 * 
 * @param filter Описание полей фильтра.
 * @param visualData Состояние визуального режима.
 */
function visualStateToQueryString(
	filter: StateFilter,
	{overview, building, section, floor, step}: StateVisualData,
	parameters: QueryParameters = {},
): string
{
	const queryParts: string[] = [
		'overview=' + encodeURIComponent(
			parameters.overviewView || overview.view || 'front',
		),
	];
	
	if ( step > StateVisualStep.OVERVIEW )
	{
		queryParts.push(
			// 'view=' + ( parameters.buildingView || building.view ),
			'building=' + ( parameters.building || building.building ),
			'view=' + ( parameters.sectionView || section.view ),
			'section=' + ( parameters.section || section.section ),
		);
	}
	
	if ( step > StateVisualStep.SECTION )
	{
		queryParts.push( 'floor=' + ( parameters.floor || floor.floor ) );
	}
	
	for ( const checkbox of filter.roomType )
	{
		if ( checkbox.checked )
		{
			queryParts.push( 'roomType[]=' + encodeURIComponent( checkbox.value ) );
		}
	}
	
	if ( filter.squareTotal.from !== filter.squareTotal.min )
	{
		queryParts.push( 'squareTotalFrom=' + filter.squareTotal.from );
	}
	
	if ( filter.squareTotal.to !== filter.squareTotal.max )
	{
		queryParts.push( 'squareTotalTo=' + filter.squareTotal.to );
	}
	
	if ( filter.totalCost.from !== filter.totalCost.min )
	{
		queryParts.push( 'totalCostFrom=' + filter.totalCost.from );
	}
	
	if ( filter.totalCost.to !== filter.totalCost.max )
	{
		queryParts.push( 'totalCostTo=' + filter.totalCost.to );
	}
	
	return queryParts.join( '&' );
}

interface QueryParameters
{
	/** Внутреннее название вида общего экрана */
	overviewView?: string;
	/** Внутреннее название вида корпуса */
	buildingView?: string;
	/** Корпус */
	building?: string;
	/** Внутреннее название вида секции */
	sectionView?: string;
	/** Секция */
	section?: string;
	/** Этаж */
	floor?: number;
}

/**
 * Module.
 */
export {
	visualStateToQueryString as default,
	QueryParameters,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/visualStateToQueryString.ts